import React__default from 'react';
import { getHeadingTag } from '../../HeadingPlugin.mjs';
import styles from './Heading.scss.mjs';

function Heading({
  attributes,
  children,
  style,
  level
}) {
  const headingElement = getHeadingTag(level);
  return /*#__PURE__*/React__default.createElement(headingElement, {
    ...attributes,
    style,
    className: styles.Heading
  }, children);
}

export { Heading };
